import React, { Component } from 'react';
import baseUrl from "../../baseUrl";
class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <div className="footer-container footer-container--auto-height">
                <div className="inner-footer col-12">
                    <div className="__links">
                        <a href="http://www.rsgis.msu.edu/">
                            <picture>
                                <source srcSet={`${baseUrl.public}img/rsgis-logo.webp`} type="image/webp" />
                                <source srcSet={`${baseUrl.public}img/rsgis-logo.png`} type="image/png" />
                                <img title="View RS&amp;GIS Homepage" src={`${baseUrl.public}img/rsgis-logo.png`} className="rsgis-logo" alt="RS&amp;GIS Logo" />
                            </picture>
                        </a> | <a className="btn btn-link" href="http://eq.ingham.org/" title="View The Equalization Department">Equalization</a> | <a className="btn btn-link" title="View BS&amp;A" href="https://bsaonline.com/Home/Index?uid=383">BS&amp;A</a>
                    </div>
                        <p className="disclaimer"><strong>Disclaimer: </strong>The data is provided for reference only and WITHOUT WARRANTY of any kind.</p>
                    </div>
            </div>
        );
    }
}
export default Footer;
